import { render } from "./button-bubble-br.vue?vue&type=template&id=1f28bc68&scoped=true"
const script = {}

import "./button-bubble-br.vue?vue&type=style&index=0&id=1f28bc68&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f28bc68"],['__file',"src/views/other/cssfx/components/button-bubble-br.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f28bc68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f28bc68', __exports__)) {
    console.log('reload')
    api.reload('1f28bc68', __exports__)
  }
  
  module.hot.accept("./button-bubble-br.vue?vue&type=template&id=1f28bc68&scoped=true", () => {
    console.log('re-render')
    api.rerender('1f28bc68', render)
  })

}


export default __exports__